var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatmapChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.802,
    height: 79.552,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37307"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#e83a3a",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M8.332 8.031h13v13h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.832 8.531h12v12h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#dc1e1e",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M20.332 8.031h13v13h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.832 8.531h12v12h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#eb4f4f",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M32.332 8.031h14v13h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M32.832 8.531h13v12h-13z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#ff7575",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M44.332 8.031h14v13h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M44.832 8.531h13v12h-13z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#ff9e9e",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M57.332 8.031h13v13h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M57.832 8.531h12v12h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#dc1e1e",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M8.332 20.031h13v14h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.832 20.531h12v13h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#a20000",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M20.332 20.031h13v14h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.832 20.531h12v13h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#bf1a1a",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M32.332 20.031h14v14h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M32.832 20.531h13v13h-13z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#ff7575",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M44.332 20.031h14v14h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M44.832 20.531h13v13h-13z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#ff7575",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M57.332 20.031h13v14h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M57.832 20.531h12v13h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#ff5757",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M8.332 32.031h13v14h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.832 32.531h12v13h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#eb3939",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M20.332 32.031h13v14h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.832 32.531h12v13h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#e53d3d",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M32.332 32.031h14v14h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M32.832 32.531h13v13h-13z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#ff7575",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M44.332 32.031h14v14h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M44.832 32.531h13v13h-13z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#dc1e1e",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M57.332 32.031h13v14h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M57.832 32.531h12v13h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#ff7575",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M8.332 44.031h13v14h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.832 44.531h12v13h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#ffa2a2",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M20.332 44.031h13v14h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.832 44.531h12v13h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#ff7575",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M32.332 44.031h14v14h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M32.832 44.531h13v13h-13z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#dc1e1e",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M44.332 44.031h14v14h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M44.832 44.531h13v13h-13z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#a20000",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M57.332 44.031h13v14h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M57.832 44.531h12v13h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#fbb",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M8.332 57.031h13v13h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.832 57.531h12v12h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#fca0a0",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M20.332 57.031h13v13h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.832 57.531h12v12h-12z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#ff7575",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M32.332 57.031h14v13h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M32.832 57.531h13v12h-13z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#ff7575",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M44.332 57.031h14v13h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M44.832 57.531h13v12h-13z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17438",
    fill: "#dc1e1e",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M57.332 57.031h13v13h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M57.832 57.531h12v12h-12z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21670",
    d: "M1.001 1v77.552h76.8",
    fill: "none",
    stroke: "#5e708d",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmapChart);
export default __webpack_public_path__ + "static/media/heatmapChart.4bfedc07f1c9ba1aca1cd8c276cb8da1.svg";
export { ForwardRef as ReactComponent };